import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

/**
 * Triggers a Calendly sync for the given account.
 * The calling user must have Calendly connected in their profile integrations.
 *
 * @param {string} accountId - Firestore account document ID
 * @returns {Promise<{ success: boolean, synced: number, total: number, message?: string }>}
 */
export const syncCalendlyMeetings = async (accountId) => {
  const fn = httpsCallable(functions, 'syncCalendlyMeetings');
  const result = await fn({ accountId });
  return result.data;
};

/**
 * Syncs lead discovery/onboarding call dates from Calendly for the given lead account.
 * @param {string} accountId - Firestore account document ID
 * @returns {Promise<{ success: boolean, updated: boolean, discoveryCallDate?: string | null, onboardingCallDate?: string | null }>}
 */
export const syncLeadCalendlyCalls = async (accountId) => {
  const fn = httpsCallable(functions, 'syncLeadCalendlyCalls');
  const result = await fn({ accountId });
  return result.data;
};
